import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsMenuComponent } from './details-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,

    RouterModule,
    MatIconModule
  ],
  declarations: [DetailsMenuComponent]
})
export class DetailsMenuModule { }
